import { useCallback } from 'react';
import { isCallback, isDependencies, isOptions } from './generic';
import { useClient } from './use-client';
import { firstOfType } from '@resolve-js/core';

function useCommand(command, options, callback, dependencies) {
  var client = useClient();
  var actualOptions = firstOfType(isOptions, options);
  var actualCallback = firstOfType(isCallback, options, callback);
  var actualDependencies = firstOfType(isDependencies, options, callback, dependencies);

  if (typeof command === 'function') {
    if (isDependencies(actualDependencies)) {
      return useCallback(function () {
        return client.command(command.apply(void 0, arguments), actualOptions, actualCallback);
      }, [client].concat(actualDependencies));
    }

    return function () {
      return client.command(command.apply(void 0, arguments), actualOptions, actualCallback);
    };
  }

  if (isDependencies(actualDependencies)) {
    return useCallback(function () {
      return client.command(command, actualOptions, actualCallback);
    }, [client].concat(actualDependencies));
  }

  return function () {
    return client.command(command, actualOptions, actualCallback);
  };
}

export { useCommand };
//# sourceMappingURL=use-command.js.map